<template lang="pug">
  .student-actions
    .d-flex.align-center
      p(v-if="!actionsByType[subjectType] && !$loader.isLoading")
        span(v-if="loading.actionsLoading") Поиск консультаций, заданий...
        span(v-else) Ничего не найдено...
      v-btn-toggle.mt-3(
        v-model="subjectType"
        mandatory
        rounded
      )
        v-badge(
          v-for="(action, idx) in  SUBJECT_TYPES_ITEMS"
          :key="idx"
          v-if="actionsByType[action.value].length"
          :value="messagesCount[action.value]"
          icon="mdi-message"
          overlap
        )
          v-btn(
            :value="action.value"
            color="secondary"
            outlined
          )
            .mx-3
              span {{ action.name }}
              strong.ml-2 +{{ pagination[action.value].total }}

      v-spacer
      tooltip-wrap(text="Обновить список")
        v-btn(fab outlined text
          :loading="loading.actionsLoading"
          @click="init([], true)"
        )
          v-icon mdi-refresh

    v-radio-group(
      v-model="type"
      row
      mandatory
    )
      v-radio(
        v-for="(item, idx) in TYPES_ITEMS"
        :key="idx"
        :label="item.name || 'Все'"
        color="secondary"
        :value="item.value"
      ).mx-2

    v-row.tasks-list
      v-col(cols=12)
        actions-list(
          :init="loading.actionsLoading"
          :actions="currentActions"
          :subject-type="subjectType"
        )
        v-pagination(
          v-if="subjectType && pagination[subjectType].pages > 1"
          v-model="pagination[subjectType].page"
          :length="pagination[subjectType].pages"
          @input="fetchActions(tags)"
        )

</template>

<script>
import {
  SUBJECT_TYPES, SUBJECT_TYPES_ITEMS, INITIAL_PAGINATION,
  TYPES, TYPES_ITEMS, SUBJECT_TYPES_FILTERS,
} from '../constants';

import { getNotificationsByItem } from '../../Courses/utils';

import ActionsList from './StudentActionsList.vue';

export default {
  components: {
    ActionsList,
  },
  props: {
    escortMode: { type: Boolean, default: false },
    moduleId: { type: Number, default: null },
  },
  data() {
    return {
      type: null,
      tags: [],
      subjectType: 1,

      actions: [],
      actionsByType: {
        [SUBJECT_TYPES.lesson]: [],
        [SUBJECT_TYPES.unit]: [],
        [SUBJECT_TYPES.course]: [],
      },
      myGroups: {
        [SUBJECT_TYPES.lesson]: [],
        [SUBJECT_TYPES.unit]: [],
        [SUBJECT_TYPES.course]: [],
      },

      TYPES,
      TYPES_ITEMS,
      SUBJECT_TYPES_ITEMS,
      SUBJECT_TYPES,
      INITIAL_PAGINATION,

      pagination: INITIAL_PAGINATION,

      loading: {
        actionsLoading: true,
      },
    };
  },
  computed: {
    // curentPagination() {
    //   const { }
    //   return this.pagination[this.subjectType]
    // }
    currentActions() {
      return this.actionsByType[this.subjectType] || [];
    },

    messagesCount() {
      return {
        [SUBJECT_TYPES.lesson]: this.actionsByType[SUBJECT_TYPES.lesson]
          .filter((i) => i.hasMessages).length,
        [SUBJECT_TYPES.unit]: this.actionsByType[SUBJECT_TYPES.unit]
          .filter((i) => i.hasMessages).length,
        [SUBJECT_TYPES.course]: this.actionsByType[SUBJECT_TYPES.course]
          .filter((i) => i.hasMessages).length,
      };
    },
  },

  watch: {
    type() {
      // this.subjectType = null;
      this.init();
    },
    // subjectType() {
    //   this.fetchActions();
    // },
  },
  async created() {
    if (!this.escortMode) {
      await Promise.all([
        this.fetchGroups('teacher'),
        this.fetchGroups('curator'),
      ]).then(() => {
        this.init();
      });
    } else this.init();
  },

  methods: {
    async init(tags, resetTags) {
      this.tags = tags || this.tags;
      if (resetTags) {
        this.tags = [];
        this.$emit('resetTags');
      }
      this.pagination = INITIAL_PAGINATION;
      this.fetchActions(this.tags, SUBJECT_TYPES.lesson);
      this.fetchActions(this.tags, SUBJECT_TYPES.unit);
      this.fetchActions(this.tags, SUBJECT_TYPES.course);
    },
    async getConsultations(tags, modulesFiters, type, page) {
      const { items, pagination } = await this.$api.chat.getConsultations({
        group_id: this.myGroups[type].map((i) => i.id),
        course_unit_only_uncompleted: true,
        lesson_only_uncompleted: true,
        tags,
        [SUBJECT_TYPES_FILTERS[type]]: true,
        ...modulesFiters,
      }, { page });
      const consultations = await getNotificationsByItem(items);
      // this.actions.push(...());
      return { pagination, consultations };
    },

    async getJournalAnswers(tags, modulesFiters, type, page) {
      const payload = { tags, ...modulesFiters, [SUBJECT_TYPES_FILTERS[type]]: true };
      const {
        items: tasks, pagination,
      } = await this.$api.journal.getJournalAnswerByGroups(payload, { page });
      this.actions = [
        ...this.actions,
        ...tasks,
      ];
      return { pagination, tasks };
    },

    async fetchGroups(searchType) {
      const search = `search[${searchType}]`;
      const query = {
        ...this.escortMode ? {
          'search[my_modules]': true,
          'search[module_id]': this.moduleId,
        } : { [search]: this.$user.data.id },
      };
      const { data } = await this.$api.groups.getGroupList(query);
      if (searchType === 'curator') this.myGroups[SUBJECT_TYPES.course] = data.data;
      else {
        this.myGroups[SUBJECT_TYPES.lesson] = data.data;
        this.myGroups[SUBJECT_TYPES.unit] = data.data;
      }
      return false;
      // const myGroups = data.reduce((acc, cur) => {
      //   const isTeacher = cur.teachers.map((i) => i.id).includes(this.$user.data.id);
      //   if (isTeacher) {
      //     acc[SUBJECT_TYPES.lesson].push(cur);
      //     acc[SUBJECT_TYPES.unit].push(cur);
      //   }
      //   return acc;
      // }, {
      //   [SUBJECT_TYPES.lesson]
      // });
      // this.myGroups = data.data;
    },

    async fetchActions(tags, initType) {
      this.loading.actionsLoading = true;
      let modulesFiters = {};

      const subjectType = initType || this.subjectType;
      const {
        escortMode, moduleId, type, pagination,
      } = this;

      const {
        consult, journal, page,
      } = pagination[subjectType];

      if (escortMode) modulesFiters.my_modules = true;
      if (moduleId) modulesFiters = { module_id: moduleId };

      let actions = [];
      if ((!type || type === TYPES.consultation) && consult.pages >= page) {
        const {
          pagination: consPagination,
          consultations,
        } = await this.getConsultations(tags, modulesFiters, subjectType, page);
        pagination[subjectType].consult = consPagination;
        actions = [...actions, ...consultations];
      }

      if ((!type || type === TYPES.taskCheck) && journal.pages >= page) {
        const {
          pagination: jornPagination,
          tasks,
        } = await this.getJournalAnswers(tags, modulesFiters, subjectType, page);
        pagination[subjectType].journal = jornPagination;
        actions = [...actions, ...tasks];
      }
      pagination[subjectType]
        .total = pagination[subjectType].consult.total + pagination[subjectType].journal.total;
      pagination[subjectType]
        .pages = pagination[subjectType].consult.pages > pagination[subjectType]
          .journal.pages ? pagination[subjectType]
            .consult.pages : pagination[subjectType].journal.pages;

      this.actionsByType[subjectType] = actions;

      this.loading.actionsLoading = false;
    },
  },
};
</script>
